export const HEADER_LOCATION_SHAPE_IDS = 'User-Location-Shape-IDs'
export const HEADER_POSITION_LATITUDE: string = 'User-Position-Latitude'
export const HEADER_POSITION_LONGITUDE: string = 'User-Position-Longitude'
export const HEADER_USER_IS_HOME: string = 'User-Is-Home'
export const PROFILE_HEADER: string = 'profile-extension-identifier'
export const HEADER_USER_LOGGED_IN = 'user-logged-in'
export const API_REVISION = 'API-Revision'
